import wx from 'weixin-js-sdk';
import Axios from "axios";
import http from '@/http';
const ShareImpl = function(option) {
    //option是分享的配置内容*/
    const url = window.location.href.split("#")[0];
    http.signUp.getWechatConfig({
        url: url
    }).then((response) => {

        wx.config({
            debug: false,
            appId: response.data.appid,
            timestamp: response.data.timestamp,
            nonceStr: response.data.nonceStr,
            signature: response.data.signature,
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
            ]
        });

    }).catch(error => {
        window.console.log(error);
    });
    wx.ready(function() {

            wx.updateAppMessageShareData({
                title: option.shareTitle,
                desc: option.shareDesc,
                link: option.shareUrl,
                imgUrl: option.shareImg,
                success: function() {
                    console.log("分享成功");
                },
                cancel: function() {
                    console.log("取消分享");
                }
            });

            wx.updateTimelineShareData({
                title: option.shareTitle,
                desc: option.shareDesc,
                link: option.shareUrl,
                imgUrl: option.shareImg,
                success: function() {
                    console.log("分享成功");
                },
                cancel: function() {
                    console.log("取消分享");
                }
            });
        })
        /*}*/
}

export default ShareImpl